// ---------------------------------------------------------------------------
// Date-time presenter for the Access Legitimacy events grid (design v6 §3.3).
//
// Formats an event's ISO timestamp as `DD/MM/YY h:mm AM` in UTC. The grid and
// detail drawer render in UTC so every analyst sees the same wall-clock value
// regardless of browser timezone. Passed as the `formatDateTime` prop to the
// format-agnostic `AccessLegitimacyBody` (the UI package never owns the format).
//
// Distinct from `@dawn/core`'s `formatDateTime`, which is locale-based
// (`toLocaleString`) and timezone-dependent — not what this grid wants.
// Invalid input is echoed back unchanged so a bad timestamp degrades to the raw
// string rather than `Invalid Date`.
// ---------------------------------------------------------------------------

/** Formats an ISO date string as `DD/MM/YY h:mm AM` (UTC). Echoes invalid input. */
export function formatEventDateTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const day = String(d.getUTCDate()).padStart(2, '0');
  const month = String(d.getUTCMonth() + 1).padStart(2, '0');
  const year = String(d.getUTCFullYear()).slice(2);
  const hours = d.getUTCHours();
  const minutes = String(d.getUTCMinutes()).padStart(2, '0');
  const period = hours >= 12 ? 'PM' : 'AM';
  const display = hours % 12 === 0 ? 12 : hours % 12;
  return `${day}/${month}/${year} ${display}:${minutes} ${period}`;
}
